import Network from '@/services/network'
import { ref } from 'vue'

export default function handleAuthorizedRoutes() {
    const network = new Network;
    
    const getAuthorizedRoutes = (query) => {
      return network.api('get', 'get/company/page-routes' + query);
    }
  
    return {
        getAuthorizedRoutes
    }
  }